<template>
    <div class="container">
        <!--        <div class="row">-->
        <!--            <div class="col-md-6 col-sm-6 offset-md-3 offset-md-3 mt-5">-->
        <!--                <app-card :title="$t('Register')">-->
        <!--                    <validation-observer v-slot="{ validate }" slim>-->
        <!--                        <form @submit.prevent="register(validate)">-->
        <!--                            <app-input id="name" v-model="form.name" name="name" rules="required">-->
        <!--                                <template #label>-->
        <!--                                    {{ $t('Name') }}*-->
        <!--                                </template>-->
        <!--                            </app-input>-->

        <!--                            <app-input id="email" v-model="form.email" name="email" rules="required|email" type="email">-->
        <!--                                <template #label>-->
        <!--                                    {{ $t('Email') }}*-->
        <!--                                </template>-->
        <!--                            </app-input>-->

        <!--                            <app-input id="password" v-model="form.password" name="password" rules="required|password:@password_confirmation" type="password">-->
        <!--                                <template #label>-->
        <!--                                    {{ $t('Password') }}*-->
        <!--                                </template>-->
        <!--                            </app-input>-->

        <!--                            <app-input id="password_confirmation" v-model="form.password_confirmation" rules="required" name="password_confirmation" type="password">-->
        <!--                                <template #label>-->
        <!--                                    {{ $t('Confirm password') }}*-->
        <!--                                </template>-->
        <!--                            </app-input>-->

        <!--                            <app-button :loading="loading" small>-->
        <!--                                {{ $t('Register') }}-->
        <!--                            </app-button>-->
        <!--                            <router-link to="/auth/login" class="btn btn-outline-info btn-sm ml-2" exact>-->
        <!--                                {{ $t('Log in') }}-->
        <!--                            </router-link>-->
        <!--                            <router-link :to="{name: 'password.request'}" class="btn btn-outline-success btn-sm ml-2" exact>-->
        <!--                                {{ $t('Forgot password') }}-->
        <!--                            </router-link>-->
        <!--                            <router-link to="/" class="btn btn-outline-success btn-sm ml-2" exact>-->
        <!--                                {{ $t('Public') }}-->
        <!--                            </router-link>-->
        <!--                        </form>-->
        <!--                    </validation-observer>-->
        <!--                </app-card>-->
        <!--            </div>-->
        <!--        </div>-->
    </div>
</template>

<script>
export default {
    data() {
        return {
            form: {
                name: '',
                email: '',
                password: '',
            },
            loading: false
        };
    },
    methods: {
        register(validate) {
            validate().then(valid => {
                if (valid) {
                    this.loading = true;
                    // this.$store.dispatch('REGISTER', this.form);
                }
            });
        }
    },
};
</script>
